module.exports = __webpack_public_path__ + "img/main_image3.a0a49c29.png";